<template>
  <div class="container">
    <van-nav-bar title="设备列表" left-text="" 
      left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon name="search" size="18" />
      </template>
    </van-nav-bar>

    <van-tabs @click="changeTab"
      color="#2FAAFF"
      title-inactive-color="#474542"
      title-active-color="#2FAAFF"
      v-model="tab_active" 
      swipeable>
      <van-tab :title="'总数'+statistics.total">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div class="list clearfix" :key="index" v-for="(item,index) in projectList">
              <div class="flex mg10">
                <div>设备编号：{{item.mainNo}}</div>
                <div><span :class="item.statusDesc == '离线'?'bg_c':'bg_b'" class="dian"></span> {{item.statusDesc}}</div>
              </div>
              <div class="bold mg10">{{item.fullCommunityName}}</div>
              <div class="flex mg10">
                <div>位置：{{item.location}}</div>
                <div><van-switch :value="item.isEnabled" @input="onChange(item,index)" size="20px" /></div>
              </div>
              <div class="bold mg10">{{item.lastOnTime}}</div>
              
              <van-collapse v-model="activeNames" :border="false">
                <van-collapse-item :name="item.mainNo" :border="false">
                  <template #title>
                    <div>
                      <span class="col_b">充电中({{item.chargingCount}})</span>
                      <span class="fg"></span>
                      <span>空闲({{item.freeCount}})</span>
                      <span class="fg"></span>
                      <span class="col_r">故障({{item.errorCount}})</span>
                    </div>
                  </template>
                  <van-grid :gutter="10" :column-num="5" :border="false">
                    <van-grid-item :class="obj.class" v-for="obj in item.deviceLoopStatusList" :key="obj.loopNo">
                      {{obj.loopNo}}
                    </van-grid-item>
                  </van-grid>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </van-list>  
      </van-tab>
      <van-tab :title="'在线'+statistics.onlines">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div class="list clearfix" :key="index" v-for="(item,index) in projectList">
              <div class="flex mg10">
                <div>设备编号：{{item.mainNo}}</div>
                <div><span :class="item.statusDesc == '离线'?'bg_c':'bg_b'" class="dian"></span> {{item.statusDesc}}</div>
              </div>
              <div class="bold mg10">{{item.fullCommunityName}}</div>
              <div class="flex mg10">
                <div>位置：{{item.location}}</div>
                <div><van-switch :value="item.isEnabled" @input="onChange(item,index)" size="20px" /></div>
              </div>
              <div class="bold mg10">{{item.lastOnTime}}</div>
              
              <van-collapse v-model="activeNames" :border="false">
                <van-collapse-item :name="item.mainNo" :border="false">
                  <template #title>
                    <div>
                      <span class="col_b">充电中({{item.chargingCount}})</span>
                      <span class="fg"></span>
                      <span>空闲({{item.freeCount}})</span>
                      <span class="fg"></span>
                      <span class="col_r">故障({{item.errorCount}})</span>
                    </div>
                  </template>
                  <van-grid :gutter="10" :column-num="5" :border="false">
                    <van-grid-item :class="obj.class" v-for="obj in item.deviceLoopStatusList" :key="obj.loopNo">
                      {{obj.loopNo}}
                    </van-grid-item>
                  </van-grid>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </van-list>
      </van-tab>
      <van-tab :title="'离线'+statistics.offlines">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div class="list clearfix" :key="index" v-for="(item,index) in projectList">
              <div class="flex mg10">
                <div>设备编号：{{item.mainNo}}</div>
                <div><span :class="item.statusDesc == '离线'?'bg_c':'bg_b'" class="dian"></span> {{item.statusDesc}}</div>
              </div>
              <div class="bold mg10">{{item.fullCommunityName}}</div>
              <div class="flex mg10">
                <div>位置：{{item.location}}</div>
                <div><van-switch :value="item.isEnabled" @input="onChange(item,index)" size="20px" /></div>
              </div>
              <div class="bold mg10">{{item.lastOnTime}}</div>
              
              <van-collapse v-model="activeNames" :border="false">
                <van-collapse-item :name="item.mainNo" :border="false">
                  <template #title>
                    <div>
                      <span class="col_b">充电中({{item.chargingCount}})</span>
                      <span class="fg"></span>
                      <span>空闲({{item.freeCount}})</span>
                      <span class="fg"></span>
                      <span class="col_r">故障({{item.errorCount}})</span>
                    </div>
                  </template>
                  <van-grid :gutter="10" :column-num="5" :border="false">
                    <van-grid-item :class="obj.class" v-for="obj in item.deviceLoopStatusList" :key="obj.loopNo">
                      {{obj.loopNo}}
                    </van-grid-item>
                  </van-grid>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </van-list>
      </van-tab>
      <van-tab :title="'禁用'+statistics.unInstalls">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
          @load="onLoad"
        >
          <div class="list-box">
            <div class="list clearfix" :key="index" v-for="(item,index) in projectList">
              <div class="flex mg10">
                <div>设备编号：{{item.mainNo}}</div>
                <div><span :class="item.statusDesc == '离线'?'bg_c':'bg_b'" class="dian"></span> {{item.statusDesc}}</div>
              </div>
              <div class="bold mg10">{{item.fullCommunityName}}</div>
              <div class="flex mg10">
                <div>位置：{{item.location}}</div>
                <div><van-switch :value="item.isEnabled" @input="onChange(item,index)" size="20px" /></div>
              </div>
              <div class="bold mg10">{{item.lastOnTime}}</div>
              <div class="mg10">禁用原因：{{item.disabledNoteDesc}}</div>
              
              <van-collapse v-model="activeNames" :border="false">
                <van-collapse-item :name="item.mainNo" :border="false">
                  <template #title>
                    <div>
                      <span class="col_b">充电中({{item.chargingCount}})</span>
                      <span class="fg"></span>
                      <span>空闲({{item.freeCount}})</span>
                      <span class="fg"></span>
                      <span class="col_r">故障({{item.errorCount}})</span>
                    </div>
                  </template>
                  <van-grid :gutter="10" :column-num="5" :border="false">
                    <van-grid-item :class="obj.class" v-for="obj in item.deviceLoopStatusList" :key="obj.loopNo">
                      {{obj.loopNo}}
                    </van-grid-item>
                  </van-grid>
                </van-collapse-item>
              </van-collapse>
            </div>
          </div>
        </van-list>
      </van-tab>
      <van-tab :title="'未激活'+statistics.unActives">
        <div class="list-box">
          <div class="list clearfix" :key="index" v-for="(item,index) in unActivedList">
            <div class="flex">
              <div>设备编号：{{item.mainNo}}</div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showPopup" :close-on-click-overlay='false' round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="name"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Toast,Loading,Tab,Tabs,List,Collapse, CollapseItem,Grid,GridItem,Switch,Popup,Picker} from 'vant';
  export default {
    data() {
      return {
        isPro: '',//父级页面来源
        keyword:'',
        allCount:0,
        pageIndex:1,
        pageSize:10,
        tab_active: 0,
        communityId:0,
        deviceStatus:'',//设备状态
        loading: false,
        finished:false,
        projectList:[],
        unActivedList:[],
        activeNames:[],
        statistics:{
          sum:0,
          onlines:0,
          offlines:0,
          unInstalls:0
        },
        columns:[
          {name:'设备故障',value:1},
          {name:'线路故障',value:2},
          {name:'网络欠费',value:3},
          {name:'电表欠费',value:4},
          {name:'暂停使用',value:5},
        ],
        showPopup:false,
        changeItem: null,
        changeIndex: null
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [Tab.name]:Tab,
      [Tabs.name]:Tabs,
      [List.name]:List,
      [Collapse.name]:Collapse,
      [CollapseItem.name]:CollapseItem,
      [Grid.name]:Grid, 
      [GridItem.name]:GridItem,
      [Switch .name]: Switch,
      [Popup.name]:Popup,
      [Picker.name]:Picker,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"})
      },
      changeTab(){
        this.pageIndex = 1;
        this.finished = false;
        if(this.tab_active == 0){
          this.deviceStatus = '';
        }else if(this.tab_active == 1){
          this.deviceStatus = 1;
        }else if(this.tab_active == 2){
          this.deviceStatus = 0;
        }else if(this.tab_active == 3){
          // 禁用
          this.deviceStatus = -1;
        }else if(this.tab_active == 4){
          //未激活
          this.getunactivedlist();
        }
        this.getProjectList();
      },
      onLoad(){
        // 异步更新数据
        setTimeout(()=>{
          this.pageIndex++;
          this.getMoreList();
        },500)
      },
      onChange(item,index){
        this.changeItem = item;
        this.changeIndex = index;
        if(item.isEnabled){
          this.showPopup = true;
        }else{
          this.projectList[index].isEnabled = true;
          axios.get("/device/setenabled?isEnabled=1"+"&mainNo="+this.changeItem.mainNo).then((res)=>{
            if(res.isSuccess){
              this.pageIndex = 1;
              this.finished = false;
              this.getProjectList();
            }
          })
        }
      },
      onCancel(){
        //取消
        this.showPopup = false;
      },
      onConfirm(item) {
        var index = this.changeIndex;
        this.projectList[index].isEnabled = false;
        axios.get("/device/setenabled?isEnabled=0"+"&mainNo="+this.changeItem.mainNo+"&disabledNote="+item.value,{}).then((res)=>{
          if(res.isSuccess){
            this.pageIndex = 1;
            this.finished = false;
            this.getProjectList();
          }
        })
        this.showPopup = false;
      },
      getunactivedlist() {
        //首页各个数据统计
        axios.get("/device/getunactivedlist",{}).then((res)=>{
          this.unActivedList = res.data;
        })
      },
      getProjectList() {
        this.loading = true;
        axios.post("/device/devicepagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            communityId: this.communityId,
            deviceStatus: this.deviceStatus
          }
        }).then((res)=>{
          // 加载状态结束
          this.loading = false;
          this.projectList = res.data.pages.list;
          this.allCount = res.data.pages.total;
          this.statistics = res.data.statistics;
          if(this.projectList.length > 0){
            this.projectList.forEach(list => {
              list.deviceLoopStatusList.forEach(item => {
                //充电-2  空闲-3  故障-4
                if(item.status == 2){
                  item.class = 'charging'
                }else if(item.status == 3){
                  item.class = 'free'
                }else if(item.status == 4){
                  item.class = 'error'
                }else{
                  item.class = ''
                }
              });
            })
          }  
        })
      },
      getMoreList() {
        axios.post("/device/devicepagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            communityId: this.communityId,
            deviceStatus: this.deviceStatus
          }
        }).then((res)=>{
          this.projectList = this.projectList.concat(res.data.pages.list);
          this.allCount = res.data.pages.total;
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
          if(this.projectList.length > 0){
            this.projectList.forEach(list => {
              list.deviceLoopStatusList.forEach(item => {
                //充电-2  空闲-3  故障-4
                if(item.status == 2){
                  item.class = 'charging'
                }else if(item.status == 3){
                  item.class = 'free'
                }else if(item.status == 4){
                  item.class = 'error'
                }else{
                  item.class = ''
                }
              });
            })
          }
        })
      },
      onClickLeft() {
        if(this.isPro == 1){
          this.$router.replace({path: "projectList.html"});
        }else{
          this.$router.replace({path: "home.html"});
        }
        
      },
      onClickRight() {
        this.$router.push({path: "search.html",query:{pageType: 2}});
      },
    },
    computed:{
    },
    created () {
      this.keyword = this.$route.query.keyword;
      this.tab_active = this.$route.query.tab_active*1 || 0;
      this.communityId = this.$route.query.communityId || '';
      //父级页面是否是项目管理
      this.isPro = this.$route.query.isPro;
      if(this.tab_active == 1){
        //在线
        this.deviceStatus = 1;
      }else if(this.tab_active == 2){
        //离线
        this.deviceStatus = 0;
      }else if(this.tab_active == 3){
        //禁用
        this.deviceStatus = -1;
      }else if(this.tab_active == 4){
        //未激活
        this.getunactivedlist();
      }
      this.getProjectList();
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
  }
  .list-box{
    width: 100%;
    color: #373737;
    .list{
      font-size: 14px;
      width: 100%;
      background: #fff;
      margin: 12px 0;
      padding: 12px;
      .fl_left{}
      .fl_right{text-align: right;}
    }
    .fg{
      width: 2px;
      height: 16px;
      display: inline-block;
      background: #7BC9FF;
      margin: 0 20px;
      vertical-align: middle;
    }
    .dian{
      width: 8px;
      height: 8px;
      border-radius: 8px;
      display: inline-block;
      vertical-align: middle;
    }
    .mg10{margin-bottom: 10px;}
    .bold{font-weight: bold;}
  }

  /deep/.van-cell{padding: 0;}
  /deep/.van-cell__right-icon {color: #5BA7FC;}
  /deep/.van-collapse-item__content{padding: 12px 0;}
  /deep/.van-grid-item__content{
    padding: 8px;
    color: #373737;
    border-radius: 4px;
    background: #e8fcff;
  }

  /deep/.charging .van-grid-item__content{
    color: #fff;
    background: #7BC9FF;
  }
  /deep/.error .van-grid-item__content{
    color: #fff;
    background: #FF4F45;
  }
</style>
